export const FETCH_VISITS_REQUEST = 'FETCH_VISITS_REQUEST';
export const FETCH_VISITS_SUCCESS = 'FETCH_VISITS_SUCCESS';
export const FETCH_VISITS_FAILURE = 'FETCH_VISITS_FAILURE';

export const CREATE_VISIT_REQUEST = 'CREATE_VISIT_REQUEST';
export const CREATE_VISIT_SUCCESS = 'CREATE_VISIT_SUCCESS';
export const CREATE_VISIT_FAILURE = 'CREATE_VISIT_FAILURE';

export const UPDATE_VISIT_REQUEST = 'UPDATE_VISIT_REQUEST';
export const UPDATE_VISIT_SUCCESS = 'UPDATE_VISIT_SUCCESS';
export const UPDATE_VISIT_FAILURE = 'UPDATE_VISIT_FAILURE';

export const DELETE_VISIT_REQUEST = 'DELETE_VISIT_REQUEST';
export const DELETE_VISIT_SUCCESS = 'DELETE_VISIT_SUCCESS';
export const DELETE_VISIT_FAILURE = 'DELETE_VISIT_FAILURE';

export const fetchVisitsRequest = (projectId, options = {}) => {
    const { page = 1, limit = 1, search = '' } = options;
    return {
      type: FETCH_VISITS_REQUEST,
      payload: { projectId, page, limit, search },
      
    };
    
  };
export const fetchVisitsSuccess = (visits) => ({ type: FETCH_VISITS_SUCCESS, payload: visits });
export const fetchVisitsFailure = (error) => ({ type: FETCH_VISITS_FAILURE, payload: error });

export const createVisitRequest = (data, projectId) => ({ type: CREATE_VISIT_REQUEST, payload: { data, projectId } });
export const createVisitSuccess = (visit) => ({ type: CREATE_VISIT_SUCCESS, payload: visit });
export const createVisitFailure = (error) => ({ type: CREATE_VISIT_FAILURE, payload: error });

export const updateVisitRequest = (id, data,projectId) => ({ type: UPDATE_VISIT_REQUEST, payload: { id, data,projectId } });
export const updateVisitSuccess = (visit) => ({ type: UPDATE_VISIT_SUCCESS, payload: visit });
export const updateVisitFailure = (error) => ({ type: UPDATE_VISIT_FAILURE, payload: error });

export const deleteVisitRequest = (projectId,id) => ({ type: DELETE_VISIT_REQUEST, payload: {id,projectId} });
export const deleteVisitSuccess = (id) => ({ type: DELETE_VISIT_SUCCESS, payload: id });
export const deleteVisitFailure = (error) => ({ type: DELETE_VISIT_FAILURE, payload: error });
